import Svg_Icon from 'root/module/svg_icon';
import Util from 'root/module/util';
import View from 'view/base';

export function getLauncherIcon(icon, icon_url) {
    switch (icon) {
        case 1:
            return Svg_Icon.widget_chat;
        case 2:
            return Svg_Icon.widget_comment_smile;
        case 3: // deprecated
            return Svg_Icon.widget_video;
        case 4:
            return Svg_Icon.widget_question;
        case 5:
            return Svg_Icon.widget_stars;
        case 6:
            return Svg_Icon.widget_bug;
        case 7:
            return Svg_Icon.widget_pointer;
        case 99:
            if (icon_url) {
                return '<img src="' + icon_url + '">';
            } else {
                return '';
            }
        default:
            return '';
    }
}

export default View.extend({
    className: 'launcher-preview',

    render: function(render_success) {
        var content = '';

        var icon_svg = getLauncherIcon(this.model.get('icon'), this.model.get('icon_url'));

        if (this.model.get('style') === 'circle') {
            content += icon_svg;
        } else {
            content += icon_svg + (Util.htmlEntities(this.model.get('main_button_text') || 'Feedback'));
        }

        content +=
        '<style>' +
        '.launcher-preview {' +
            '--widget-preview-launcher-offset-x: ' + this.model.get('launcher_offset_x') + 'px;' +
            '--widget-preview-launcher-offset-y: ' + this.model.get('launcher_offset_y') + 'px;' +
        '}' +
        '</style>';

        this.$el.html(content);

        this.$el.attr({
            'data-icon'    : this.model.get('icon'),
            'data-style'   : this.model.get('style'),
            'data-position': this.model.get('position')
        });

        this.$el.css({
            'background-color' : this.model.get('main_button_background_colour'),
            'color'            : this.model.get('main_button_text_colour'),
        });

        this.$el.find('svg *').css({
            'fill'             : this.model.get('main_button_text_colour')
        });

        return this;
    }
});